import React from "react";
import { Paper, Typography } from "@mui/material";

const ConversionFunnel = ({ showAnalysis = false }: { showAnalysis?: boolean }) => {
  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {showAnalysis ? "Conversion Funnel Analysis" : "Conversion Funnel"}
      </Typography>
      {/* Simulated funnel using div blocks */}
      <div style={{
        height: 250,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        background: '#f7f7f7',
        borderRadius: 4
      }}>
        <div style={{ width: '80%', height: 24, background: '#3e59e3' }} />
        <div style={{ width: '60%', height: 24, background: '#3e59e3' }} />
        <div style={{ width: '40%', height: 24, background: '#3e59e3' }} />
        <div style={{ width: '25%', height: 24, background: '#3e59e3' }} />
      </div>
    </Paper>
  );
};

export default ConversionFunnel;
